import type { CommonStylesPalette } from '../types.d';

export const getMapStyle = (palette: CommonStylesPalette) => Object.assign({
  '& .map-container': {
    '& .MicrosoftMap': {
      overflow: 'hidden',
      position: 'absolute !important',
      width: 'inherit !important',
      height: 'inherit !important',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      whiteSpace: 'normal',
      lineHeight: '16px',

      '& .Infobox2': {
        marginLeft: -3,
        height: 'auto',
        top: -26,
        width: 256,
        boxShadow: '0px 1.2px 3.6px rgba(0, 0, 0, 0.108), 0px 6.4px 14.4px rgba(0, 0, 0, 0.132)',
        background: '#fff',
        border: '1px solid #edebe9',
        borderRadius: 2,

        '& .infobox-body': {
          padding: '13px 12px 9px 12px',
          fontSize: 13,
          background: '#fff',
        },

        '& .infobox-actions': {
          padding: 0,
          margin: '4px -8px 0',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },

        '& .infobox-actions-list': {
          overflow: 'hidden',
          width: '100%',
          listStyle: 'none outside none',
          lineHeight: 1.3,
          padding: 0,
          margin: '4px 0',

          '& li': {
            display: 'inline-block',
            marginBottom: 1,
            marginTop: 1,
            '&:focus-within': {
              border: `1px solid ${palette.neutralSecondary}`,
            },

            '& a': {
              padding: '0 8px',
            },

            '& a.icon': {
              width: 13,
              height: 18,
              margin: '2px 4px 2px 8px',
              padding: '2px 0 0 0',
              position: 'relative',

              '& .iconUnderline': {
                position: 'absolute',
                height: '100%',
                width: '100%',
                left: 0,
                top: -1,
              },

              '& img': {
                border: 'none',
              },
            },
          },

          '& li:last-child a': {
            border: 0,
          },

          '& .disabled a': {
            outline: 'none',
            textDecoration: 'none',
            cursor: 'default',
            color: '#888',
          },
        },

        '& .infobox-title': {
          lineHeight: 1.1,
          fontSize: 18,
          fontWeight: 'normal',
          textDecoration: 'none',
          margin: '0 4px 0 0',
          display: 'inline',
          overflow: 'hidden',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        },

        '& .infobox-titleActionLink': {
          display: 'inline',
          marginLeft: 4,
          fontSize: 13,
        },

        '& .infobox-body .infobox-info': {
          marginTop: 6,
          marginBottom: 6,

          '& a': {
            float: 'left',
          },
        },

        // Separate a, a:visited here since '& a, & a:visited' cannot work
        '& a': {
          textDecoration: 'none',
          wordBreak: 'break-word',
        },

        '& a:vistited': {
          textDecoration: 'none',
          wordBreak: 'break-word',
        },
      },
    },
  },

  '& .map-message-panel': {
    left: 6,
    position: 'absolute',
    top: 6,
    width: 292,
    zIndex: 110,
    textAlign: 'center',
    backgroundColor: palette.white,
    fontWeight: 'bold',
    padding: 2,
    boxShadow: `0 0 10px ${palette.black}`,
    display: 'none',
  },
});
